module.exports = __webpack_public_path__ + "media/new-roam.242c3d4e.mp3";